export enum AppEvents {
  GenerateAIStory = 'GenerateAIStory',
  GenerateAIStoryCancel = 'GenerateAIStoryCancel',
  GenereteAIStoryPreviewReload = 'ReloadCurrentStory', // Same as ReloadCurrentStory just nicer (descriptive) api

  // General
  DisableUserInput = 'DisableUserInput', // Touches, movement, etc.
  EnableUserInput = 'DisableUserInput', // Touches, movement, etc.

  ReloadCurrentStory = 'ReloadCurrentStory',

  OnFeedScroll = 'OnFeedScroll',

  PlayStory = 'PlayStory',

  // Maybe? 
  AIStoryComplete = 'AIStoryComplete', // Send when the "publish" flow is complete
}

export enum GameEvents {
  AIStoryCreateStarted = 'AIStoryCreateStarted',
  AIStoryCreateUpdated = 'AIStoryCreateUpdated',
  AiStoryCreateCompleted = 'AiStoryCreateCompleted',
  OnStoryReady = 'OnStoryReady',
  OnStoryProgress = 'OnStoryProgress',
  OnStoryOutcome = 'OnStoryOutcome',
  OnChoicePress = 'OnChoicePress',
}